<template>
    <dialog-form
            :open="open"
            title="Share Profile"
            width="90%"
            max-width="600"
            @close="$emit('close')"
            :saving="creatingProfileAccessLink"
            @submit="createProfileAccessLink"
            submit-button-title="Generate New Link"
    >
    <template #form-content>
    
        <SwayVisaCard :profile-access-link-url="profileAccessLink" :profile="simpleProfile"></SwayVisaCard>
    
        <div v-if="isPatientAccountCreationEnabled" style="color: #757575">
            <span>Share the link or QR code below with a Sway Administrator.</span>
        </div>
        <div v-else style="color: #757575">
            <span>Share a profile with another Sway Administrator by using the link or QR code below. The new user and their organization will be able to:</span>
            <ul>
                <li>Access profile information, test history, and event data.</li>
                <li>Take tests, baselines, and events.</li>
                <li>Any new tests or edits to profile data will be seen by all users/organizations.</li>
            </ul>
            <br>
        </div>
    
    </template>
    </dialog-form>

</template>

<script>
import SwayVisaCard from "@/components/SwayVisa/SwayVisaCard.vue";
import {generateProfileAccessLink} from "@/services/profile.service";

export default {
    name: "CreateProfileAccessDialog",
    components: {SwayVisaCard},
    props: {
        open: {
            type: Boolean
        },
        simpleProfile: {
            required: true
        },
        isPatientAccountCreationEnabled: {
            type: Boolean
        }
    },
    data() {
        return {
            profileAccessLink: "",
            creatingProfileAccessLink: false
        }
    },
    mounted() {
        this.createProfileAccessLink();
    },
    watch: {
        simpleProfile: function(newValue, oldValue) {
            this.createProfileAccessLink();
        }
    },
    methods: {
        async createProfileAccessLink() {
            if (!this.simpleProfile?.id) {
                return;
            }
            this.creatingProfileAccessLink = true;

            const response = await generateProfileAccessLink(this.simpleProfile.id, "");
            if (!response.isSuccess) {
                this.creatingProfileAccessLink = false;
                return
            }

            this.profileAccessLink = response.link;

            this.creatingProfileAccessLink = false;
        }
    },
    computed: {
        
    }
}
</script>

<style scoped>
.test-card {
    border: 1px solid #e0e0e0;
    margin: 5px 0;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
}

.test-card:hover {
    cursor: pointer;
}

.selected-test-card {
    background-color: rgba(130,203,195,.2);
    border: 1px solid rgba(130,203,195,1)
}

.dot {
    height: 8px;
    width: 8px;
    border-radius: 5px;
    background-color: red;
    margin-right: 10px;
}

.baseline {
    background-color: white;
    border: 2px solid var(--v-primary-base)
}

.event {
    background-color: var(--v-event-base);
    border: 2px solid var(--v-event-base)
}

.excluded {
    background-color: var(--v-charcoal-base);
    border: 2px solid var(--v-charcoal-base)
}

</style>